/* eslint-disable no-undef */
// import { ApolloClient } from 'apollo-client';
// import { ApolloLink } from 'apollo-link';
// import { onError } from 'apollo-link-error';
// import { HttpLink } from 'apollo-link-http';
// import { InMemoryCache } from 'apollo-cache-inmemory';

// const ApolloClient = require('apollo-client');
// const ApolloLink = require('apollo-link');
// const ApolloOnError = require('apollo-link-error');
// const HttpLink = require('apollo-link-http');
// const InMemoryCache = require('apollo-cache-inmemory');

const ApolloClient = require('apollo-client').ApolloClient;
const ApolloLink = require('apollo-link').ApolloLink;
const ApolloOnError = require('apollo-link-error').onError;
const HttpLink = require('apollo-link-http').HttpLink;
const InMemoryCache = require('apollo-cache-inmemory').InMemoryCache;
const setContext = require('apollo-link-context').setContext;

angular.module('zc.commonApi')
  .factory('Apollo', Apollo);

Apollo.$inject = ['$q', 'Devise'];
function Apollo($q, Devise) {
  const service = {
    query,
    masterQuery,
    mutate,
  };

  function createGraphQLClientForUrl(uri) {
    const httpLink = new HttpLink({
      uri,
      batchInterval: 5,
      batchMax: 5,
      credentials: 'same-origin',
      mode: 'cors',
    });

    const authLink = setContext(() =>
      Devise.getCurrentUser().then(() => {
        if(!Devise.currentUser) return;

        return {
          headers: {
            'X-LOGIN-TOKEN': Devise.currentUser.login_token,
          },
        };
      })
    );


    const errorLink = ApolloOnError(({ graphQLErrors, networkError }) => {
      if(graphQLErrors) {
        graphQLErrors.map(({ message, locations, path }) => {
          alertify.error(message, 0);
          // eslint-disable-next-line
          console.error(`[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations, null, 2)}, Path: ${path}`);
          return null;
        });
      }

      if(networkError) {
        // eslint-disable-next-line
        console.error(`[Network error]: ${networkError}`);
      }
    });


    const link = ApolloLink.from([
      authLink,
      errorLink,
      httpLink,
    ]);

    // Create the apollo client
    const apolloClient = new ApolloClient({
      link,
      cache: new InMemoryCache(),
      connectToDevTools: true,
    });
    return apolloClient;
  }

  const apolloClient = createGraphQLClientForUrl(ZC_CONFIG.GRAPHQL_URL_APP);
  const masterApolloClient = createGraphQLClientForUrl(ZC_CONFIG.GRAPHQL_URL_MASTER);

  return service;

  function query(_query, _variables) {
    const q = { query: _query };
    if(_variables) {
      q.variables = _variables;
    }

    return $q((resolve, reject) => {
      apolloClient.query(q)
        .then(res => void resolve(res.data))
        .catch(error => void reject(error));
    });
  }

  function masterQuery(_query, _variables) {
    return $q((resolve, reject) => {
      if(Devise.isCommonUser()) return resolve(null);

      const q = { query: _query };
      if(_variables) {
        q.variables = _variables;
      }

      masterApolloClient.query(q)
        .then(res => void resolve(res.data))
        .catch(error => void reject(error));
    });
  }

  function mutate(mutationOptions) {
    return $q((resolve, reject) => {
      apolloClient.mutate(mutationOptions)
        .then(res => void resolve(res.data))
        .catch(error => void reject(error));
    });
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/apollo/apollo.service.js